import Vue from "vue";
import Router from "vue-router";
import store from "@/app/store/store";
import { types } from "@/app/types/types";
import { authenticationEnum } from "@/app/enums/common";
import Login from "@/views/Login.vue";
import Start from "@/views/Start.vue";

import Customers from "@/views/customers/Customers.vue";
import CustomerShow from "@/views/customers/CustomerShow.vue";
import CustomerEdit from "@/components/customers/CustomerEdit.vue";
import CustomerAgreement from "@/components/customers/CustomerAgreement.vue";
import GeneratePDFs from "@/components/customers/GeneratePDFs.vue";

import PersonList from "@/components/persons/PersonList.vue";
import PersonEdit from "@/components/persons/PersonEdit.vue";
import PersonsImport from "@/components/persons/PersonsImport.vue";
import PersonGroupList from "@/components/persongroups/PersonGroupList.vue";
import PersonGroupEdit from "@/components/persongroups/PersonGroupEdit.vue";
import PersonGroupShow from "@/components/persongroups/PersonGroupShow.vue";

import AgreementsShow from "@/views/agreements/AgreementsShow.vue";
import AgreementList from "@/components/agreements/AgreementList.vue";
import AgreementEdit from "@/components/agreements/AgreementEdit.vue";

import ProductsShow from "@/views/products/ProductsShow.vue";
import ProductEdit from "@/components/products/ProductEdit.vue";
import ProductList from "@/components/products/ProductList.vue";
import ProductPackageList from "@/components/productpackages/ProductPackageList.vue";
import ProductPackageEdit from "@/components/productpackages/ProductPackageEdit.vue";

import FilesList from "@/components/files/FilesList.vue";

import Orders from "@/views/orders/Orders.vue";
import OrderEdit from "@/components/orders/OrderEdit.vue";
import OrderList from "@/components/orders/OrderList.vue";
import OrdersPersonGroupShow from "@/components/orders/OrdersPersonGroupShow.vue";
import OrderSendWebshopLinks from "@/components/orders/OrderSendWebshopLinks.vue";

Vue.use(Router);

const router = new Router({
	mode: "history",
	base: process.env.BASE_URL,
	linkExactActiveClass: "active",
	routes: [
		{
			path: "/",
			name: "Login",
			component: Login,
			meta: { isLogin: true }
		},
		{
			path: "/Start",
			name: "Start",
			component: Start
		},
		{
			path: "/Institutioner",
			name: "Customers",
			alias: "CustomersRefresh",
			component: Customers,
			children: [
				{
					path: "Institution",
					name: "CustomerCreate",
					component: CustomerEdit
				},
				{
					path: ":customerid/Rediger",
					name: "CustomerEdit",
					component: CustomerEdit
				}
			]
		},
		{
			path: "/Institutioner/:customerid",
			name: "CustomerShow",
			component: CustomerShow,
			children: [
				{
					path: "Importer",
					name: "PersonsImport",
					component: PersonsImport
				},
				{
					path: "GenererPDF/:agreementid?",
					name: "GeneratePDFs",
					component: GeneratePDFs
				},
				{
					path: "Aftaler",
					name: "Agreements",
					component: AgreementList
				},
				{
					path: "Aftaler/:agreementid",
					name: "CustomerAgreement",
					component: CustomerAgreement,
					children:
						[
							{
								path: "Grupper",
								name: "PersonGroups",
								component: PersonGroupList,
							},
							{
								path: "Gruppe",
								name: "PersonGroupCreate",
								component: PersonGroupEdit
							},
							{
								path: "Grupper/:persongroupid",
								name: "PersonGroupEdit",
								component: PersonGroupEdit
							},
							{
								path: "Grupper/Gruppe/:persongroupid",
								name: "PersonGroupShow",
								component: PersonGroupShow
							},
							{
								path: "Personer",
								name: "Persons",
								component: PersonList,
							},
							{
								path: "Person",
								name: "PersonCreate",
								component: PersonEdit
							},
							{
								path: "Personer/:personid",
								name: "PersonEdit",
								component: PersonEdit
							},
							{
								path: "Filer",
								name: "Files",
								component: FilesList
							},
						]
				},
				/*
				{
					path: "Aftale",
					name: "AgreementCreate",
					component: AgreementEdit
				},
				{
					path: "Aftaler/:agreementid",
					name: "AgreementEdit",
					component: AgreementEdit
				},
				*/
			]
		},
		{
			path: "/Aftaler",
			component: AgreementsShow,
			children: [
				{
					path: "Aftale",
					name: "AgreementCreate",
					component: AgreementEdit
				},
				{
					path: "Aftaler/:agreementid",
					name: "AgreementEdit",
					component: AgreementEdit
				},
				{
					path: "",
					name: "AgreementsAll",
					component: AgreementList,
				},
				{
					path: "Aftale",
					name: "AgreementsAllCreate",
					component: AgreementEdit
				},
				{
					path: ":customerid/:agreementid",
					name: "AgreementEditFromList",
					component: AgreementEdit
				}
			]
		},
		{
			path: "/Bestillinger",
			component: Orders,
			children: [
				{
					path: "",
					name: "Orders",
					component: OrderList,
				},
				{
					path: "Institutioner",
					name: "OrdersByCustomer",
					component: AgreementList,
				},
				{
					path: "Institutioner/:agreementid/:customerid/Grupper",
					name: "OrdersPersonGroups",
					component: PersonGroupList
				},
				{
					path: "Institutioner/:agreementid/:customerid/Gruppe/:persongroupid",
					name: "OrdersPersonGroupShow",
					component: OrdersPersonGroupShow
				},
				{
					path: "Institutioner/:agreementid/:customerid/Gruppe/:persongroupid/Bestilling/:personid/:orderid?/:isfind?/:isfromorders?",
					name: "OrderEdit",
					component: OrderEdit
				},
				{
					path: "SendLinks/:agreementid/:customerid?/:persongroupid?",
					name: "OrderSendWebshopLinks",
					component: OrderSendWebshopLinks
				},
				{
					path: "Find/:agreementid?/:customerid?/:findorderinput",
					name: "FindOrdersResult",
					component: OrdersPersonGroupShow
				}
			]
		},
		{
			path: "/Produkter",
			component: ProductsShow,
			default: "ProductPackages",
			children: [
				{
					path: "",
					name: "Products",
					component: ProductPackageList,
				},
				{
					path: "Produktpakke",
					name: "ProductPackageCreate",
					component: ProductPackageEdit
				},
				{
					path: "Produktpakker/:productpackageid",
					name: "ProductPackageEdit",
					component: ProductPackageEdit
				},
				{
					path: "Produkter",
					name: "ProductsList",
					component: ProductList,
				},
				{
					path: "Produkt",
					name: "ProductCreate",
					component: ProductEdit
				},
				{
					path: "Produkter/:productid",
					name: "ProductEdit",
					component: ProductEdit
				}
			]
		}

		/*
		{
			// will match everything (used for 404)
			path: '*'
		},
		{
			// will match anything starting with `/user-`
			path: '/user-*'
		},*/

		//
		//{
		//	path: '/barn/:name',
		//	component: () => import(/* webpackChunkName: "child" */ "../../views/parents/Child.vue")
		//}
	]
});

router.beforeEach((to, from, next) =>
{
	if (to.matched.some(record => record.meta.isLogin))
	{
		store.dispatch(types.ACTION_CHECK_IS_USER_LOGGED_IN).then(response =>
		{
			if (response == authenticationEnum.LOGGED_IN)
			{
				router.push({ name: "Start" })
			}
		})
	}
	else
	{
		store.dispatch(types.ACTION_CHECK_IS_USER_LOGGED_IN).then(response =>
		{
			if (response != authenticationEnum.LOGGED_IN)
			{
				router.push({ name: "Login" })
			}
		})
	}

	next()
})

export default router